import { message } from "antd";
import React, { useEffect, useState } from "react";
import { Doughnut } from "react-chartjs-2";
import { GetDashboardTotalCustomersChartData } from "../../../utils/api";
import { constructParams } from "./constructParams";
import Loader from "../../shared/Loader";

const options = {
  responsive: true,
  cutout: "75%",
  plugins: {
    legend: {
      display: false,
    },
  },
  layout: {
    padding: 20,
  },
  annotation: {
    annotations: [
      {
        drawTime: "afterDatasetsDraw",
        type: "text",
        id: "text-center",
        x: "50%",
        y: "50%",
        fontColor: "#000",
        text: "Center Text",
        fontSize: 12,
      },
    ],
  },
};

const CustomerRetentionRateChart = ({ selectedOption, startDate, endDate }) => {
  const [customerRetentionRate, setCustomerRetentionRate] = useState({});

  const [loading, setLoading] = useState(true);

  const fetch = async (params) => {
    try {
      setLoading(true);
      const queryParams = new URLSearchParams(params).toString();
      const response = await GetDashboardTotalCustomersChartData(queryParams);
      setCustomerRetentionRate(response?.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      message.error(error || "Unknown error occured. Please try again later.");
    }
  };

  useEffect(() => {
    const params = constructParams(selectedOption, startDate, endDate);
    fetch(params);
  }, [selectedOption, startDate, endDate]);

  const customerRetentionData = {
    labels: ["Total Customers", "Return Bookings"],
    datasets: [
      {
        data: [
          customerRetentionRate?.totalClients,
          customerRetentionRate?.totalReturnCustomer,
        ],
        backgroundColor: ["#8373B7", "#638D83"],
      },
    ],
  };
  return (
    <div className="box-shadow sm:w-6/12 w-full rounded-xl flex-1 p-4">
      <div className="flex items-center justify-between">
        <h2 className="text-sm font-semibold">Customer Retention Rate</h2>
      </div>
      <div className="w-full flex flex-col">
        <div className="w-64 h-64 ml-auto total-deleted relative">
          <div
            className={`absolute top-[70px] left-[60px] flex-col items-center text-center ${
              loading ? "hidden" : "flex"
            }`}
          >
            <span className="text-3xl font-bold">
              {customerRetentionRate?.totalClients}
            </span>
            <span className="text-2xl font-semibold">
              Total <br /> Customers
            </span>
          </div>
          {loading ? (
            <Loader height="h-[40vh]" />
          ) : (
            <Doughnut data={customerRetentionData} options={options} />
          )}
        </div>
        <div className="-mt-10 flex flex-col gap-y-3">
          <div className="flex gap-x-1 items-center">
            <div className="w-2 h-2 rounded-full bg-[#8373B7]" />
            <span className="2xl:text-sm text-[10px] font-bold mr-1">
              {customerRetentionRate?.totalClients}
            </span>
            <p className="text-[10px] 2xl:text-sm text-black-500">
              Total Customers
            </p>
          </div>
          <div className="flex gap-x-1 items-center">
            <div className="w-2 h-2 rounded-full bg-[#638D83]" />
            <span className="text-[10px] 2xl:text-sm font-bold mr-1">
              {customerRetentionRate?.totalReturnCustomer}
            </span>
            <p className="text-[10px] 2xl:text-sm text-black-500">
              Return Bookings
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerRetentionRateChart;
